module.exports = require("@olympeio/core");